import axios from 'axios'
import { UrlBase } from './config'
import { UrlBaseEvents } from '@/libs/externalProviders/configEvents.js'

const events = {}

events.getVenuesTags = (token, companyId, appId, pagination) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage
      },
      url: UrlBaseEvents +
      'admin/companies/' +
      companyId +
      '/apps/' +
      appId +
      '/venues/tags'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  })
}
events.updateVenuesTags = (token, companyId, appId, tags) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        tags
      },
      url: UrlBaseEvents +
      'admin/companies/' +
      companyId +
      '/apps/' +
      appId +
      '/venues/tags/update'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  })
}
events.createEvent = (token, companyId, appId, data) => {
  const {
    category,
    contacts,
    coverImage,
    currency,
    timeZone,
    ends,
    eventUrl,
    hasEventUrl,
    images,
    limitByDocument,
    location,
    longDescription,
    note,
    emailNote,
    place,
    planner,
    eventRating,
    priceRating,
    businessFee,
    tags,
    shortDescription,
    socialLinks,
    starts,
    tickets,
    title,
    type,
    ePaycoPublicKey,
    ePaycoPrivateKey,
    ePaycoTest,
    placeId,
    categories,
    preferences
  } = data

  return new Promise((resolve, reject) => {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/events',
      data: {
        category,
        contacts,
        coverImage,
        currency,
        timeZone,
        ends,
        eventUrl,
        hasEventUrl,
        images,
        limitByDocument,
        location,
        longDescription,
        note,
        emailNote,
        place,
        planner,
        eventRating,
        priceRating,
        businessFee,
        tags,
        shortDescription,
        socialLinks,
        starts,
        tickets,
        title,
        type,
        ePaycoPublicKey,
        ePaycoPrivateKey,
        ePaycoTest,
        placeId,
        categories,
        preferences
      }
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

events.exportData = (token, companyId, appId, eventId, filename) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: { eventId },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/events/export/file`
    }
    axios(request)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${filename}.xlsx`)
        document.body.appendChild(link)
        link.click()
        resolve(true)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

events.getEvent = (token, companyId, appId, eventId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBase +
        'companies/' +
        companyId +
        '/apps/' +
        appId +
        '/events/' +
        eventId
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

events.getEvents = (token, companyId, appId, pagination) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/events'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

events.getStatisticsTickets = async (token, companyId, appId, eventId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/events/${eventId}/attendees/statistics`
    }

    const response = await axios(request)
    return response.data.attendees
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

events.importAttendees = (
  token,
  companyId,
  appId,
  { eventId, ticketId, file }
) => {
  return new Promise((resolve, reject) => {
    const fd = new FormData()
    fd.append('upload-files', file)
    fd.append('eventId', eventId)
    fd.append('ticketId', ticketId)

    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBase +
        'companies/' +
        companyId +
        '/apps/' +
        appId +
        '/events/' +
        eventId +
        '/attendees/import',
      data: fd
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

events.updateEventProperty = (token, companyId, appId, eventId, property) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBase +
        'companies/' +
        companyId +
        '/apps/' +
        appId +
        '/events/' +
        eventId,
      data: property
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

events.updateEvent = (
  token,
  companyId,
  appId,
  eventId,
  {
    category,
    categories,
    preferences,
    contacts,
    coverImage,
    currency,
    timeZone,
    ends,
    eventUrl,
    hasEventUrl,
    images,
    limitByDocument,
    location,
    longDescription,
    note,
    emailNote,
    place,
    planner,
    eventRating,
    priceRating,
    businessFee,
    tags,
    shortDescription,
    socialLinks,
    starts,
    tickets,
    title,
    type,
    ePaycoPublicKey,
    ePaycoPrivateKey,
    ePaycoTest,
    placeId
  }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBase +
        'companies/' +
        companyId +
        '/apps/' +
        appId +
        '/events/' +
        eventId,
      data: {
        category,
        categories,
        preferences,
        contacts,
        coverImage,
        currency,
        timeZone,
        ends,
        eventUrl,
        hasEventUrl,
        images,
        limitByDocument,
        location,
        longDescription,
        note,
        emailNote,
        place,
        planner,
        eventRating,
        priceRating,
        businessFee,
        tags,
        shortDescription,
        socialLinks,
        starts,
        tickets,
        title,
        type,
        ePaycoPublicKey,
        ePaycoPrivateKey,
        ePaycoTest,
        placeId
      }
    }

    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

events.deleteEvent = async (token, companyId, appId, eventId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBase +
        'companies/' +
        companyId +
        '/apps/' +
        appId +
        '/events/' +
        eventId
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// Promotors:

events.getPromotors = (token, companyId, appId, pagination) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/promotors'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message === 'Operation canceled') return resolve(false)
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.createPromotor = (
  token,
  companyId,
  appId,
  {
    userId,
    email,
    name,
    password,
    phone,
    country,
    countryCode,
    status,
    ranking,
    location,
    locationUrl,
    fbSendMessageUrl,
    fbProfileUrl,
    rawHtml
  }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/promotors',
      data: {
        userId,
        email,
        name,
        password,
        phone,
        country,
        countryCode,
        status,
        ranking,
        location,
        locationUrl,
        fbSendMessageUrl,
        fbProfileUrl,

        rawHtml
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.updatePromotor = (
  token,
  promotorId,
  companyId,
  appId,
  {
    userId,
    email,
    name,
    password,
    phone,
    country,
    countryCode,
    status,
    ranking,
    location,
    locationUrl,
    fbSendMessageUrl,
    fbProfileUrl,
    rawHtml
  }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/promotors/' +
        promotorId,
      data: {
        userId,
        email,
        name,
        password,
        phone,
        country,
        countryCode,
        status,
        ranking,
        location,
        locationUrl,
        fbSendMessageUrl,
        fbProfileUrl,

        rawHtml
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

// upload promotor's profile photo

events.uploadPromotorProfilePhoto = async (
  token,
  companyId,
  appId,
  promotorId,
  { filesForm }
) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/promotors/' +
        promotorId +
        '/profilephoto',
      data: filesForm
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// upload promotor banner's photo

events.uploadPromotorBannerPhoto = async (
  token,
  companyId,
  appId,
  promotorId,
  { filesForm }
) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/promotors/' +
        promotorId +
        '/bannerphoto',
      data: filesForm
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

events.deletePromotor = async (token, companyId, appId, promotorId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/promotors/' +
        promotorId
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// Djs

events.getDjs = (token, companyId, appId, pagination, search) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/djs'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message === 'Operation canceled') return resolve(false)
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.createDj = (
  token,
  companyId,
  appId,
  {
    userId,
    email,
    name,
    password,
    phone,
    country,
    countryCode,
    status,
    ranking,
    location,
    locationUrl,
    fbSendMessageUrl,
    fbProfileUrl,
    rawHtml
  }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/djs',
      data: {
        userId,
        email,
        name,
        password,
        phone,
        country,
        countryCode,
        status,
        ranking,
        location,
        locationUrl,
        fbSendMessageUrl,
        fbProfileUrl,

        rawHtml
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.updateDj = (
  token,
  djId,
  companyId,
  appId,
  {
    userId,
    email,
    name,
    password,
    phone,
    country,
    countryCode,
    status,
    ranking,
    location,
    locationUrl,
    fbSendMessageUrl,
    fbProfileUrl,
    rawHtml
  }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/djs/' +
        djId,
      data: {
        userId,
        email,
        name,
        password,
        phone,
        country,
        countryCode,
        status,
        ranking,
        location,
        locationUrl,
        fbSendMessageUrl,
        fbProfileUrl,

        rawHtml
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

// upload dj's profile photo

events.uploadDjProfilePhoto = async (
  token,
  companyId,
  appId,
  djId,
  { filesForm }
) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/djs/' +
        djId +
        '/profilephoto',
      data: filesForm
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

events.deleteDj = async (token, companyId, appId, djId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/djs/' +
        djId
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// Places:

events.getPlaces = (token, companyId, appId, pagination, search) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/places'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message === 'Operation canceled') return resolve(false)
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.createPlace = (token, companyId, appId, duplicates, place) => {
  const {
    name,
    type,
    description,
    phone,
    email,
    website,
    placeLocation,
    placeLocationUrl,
    placeLocationReference,
    coverImage,
    images,
    socialLinks,
    contacts,
    active,
    city,
    state,
    country,
    zipcode,
    categories,
    preferences,
    experiences,
    offerings,
    tags,
    isRestaurant,
    diningStyle,
    dressCode,
    acceptedPaymentMethods,
    parkingType,
    priceAverage,
    brunchSchedules,
    lunchSchedules,
    happyHourSchedules,
    dinnerSchedules,
    timeZone,
    currency,
    workingHours
  } = place
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/places',
      data: {
        name,
        type,
        description,
        phone,
        email,
        website,
        placeLocation,
        placeLocationUrl,
        placeLocationReference,
        coverImage,
        images,
        socialLinks,
        contacts,
        active,
        city,
        state,
        country,
        zipcode,
        categories,
        preferences,
        experiences,
        offerings,
        tags,
        isRestaurant,
        diningStyle,
        dressCode,
        acceptedPaymentMethods,
        parkingType,
        priceAverage,
        brunchSchedules,
        lunchSchedules,
        happyHourSchedules,
        dinnerSchedules,
        timeZone,
        currency,
        workingHours
      }
    }
    /* This for works to create more than 1 place if required by the user */
    for (let times = 0; times < duplicates; times++) {
      axios(options)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.error(error)
          const errResponse = error.response
          if (!errResponse) {
            return resolve(false)
          } else {
            console.error(errResponse)
            const message = errResponse.data.error || ''
            if (message) return reject(new Error(message))
            return reject(error)
          }
        })
    }
  })
}

events.updatePlace = (
  token,
  placeId,
  companyId,
  appId,
  {
    name,
    type,
    description,
    phone,
    email,
    website,
    placeLocation,
    placeLocationUrl,
    placeLocationReference,
    coverImage,
    images,
    socialLinks,
    contacts,
    active,
    city,
    state,
    country,
    zipcode,
    categories,
    preferences,
    experiences,
    offerings,
    placeRating,
    priceRating,
    tags,
    isRestaurant,
    diningStyle,
    dressCode,
    acceptedPaymentMethods,
    parkingType,
    priceAverage,
    brunchSchedules,
    lunchSchedules,
    happyHourSchedules,
    dinnerSchedules,
    timeZone,
    currency,
    workingHours
  }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/places/' +
        placeId,
      data: {
        name,
        type,
        description,
        phone,
        email,
        website,
        placeLocation,
        placeLocationUrl,
        placeLocationReference,
        coverImage,
        images,
        socialLinks,
        contacts,
        active,
        city,
        state,
        country,
        zipcode,
        categories,
        preferences,
        experiences,
        offerings,
        placeRating,
        priceRating,
        tags,
        isRestaurant,
        diningStyle,
        dressCode,
        acceptedPaymentMethods,
        parkingType,
        priceAverage,
        brunchSchedules,
        lunchSchedules,
        happyHourSchedules,
        dinnerSchedules,
        timeZone,
        currency,
        workingHours
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.deletePlace = async (token, companyId, appId, placeId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/places/' +
        placeId
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// Products Categories

events.getProductsCategories = (token, companyId, appId, pagination, search) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.sortDesc,
        limit: pagination.itemsPerPage,
        search
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/categories/products'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message === 'Operation canceled') return resolve(false)
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.getProductsCategoriesByPlaceId = (token, companyId, appId, pagination, search, placeId) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.sortDesc,
        limit: pagination.itemsPerPage,
        search,
        placeId
      },
      url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/categories/products`
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message === 'Operation canceled') return resolve(false)
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.createProductsCategory = (
  token,
  companyId,
  appId,
  { name, description, active, placeId }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/categories/products',
      data: {
        name,
        description,
        active,
        placeId
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.updateProductsCategory = (
  token,
  productsCategoryId,
  companyId,
  appId,
  { name, description, active, images, placeId }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/categories/products/' +
        productsCategoryId,
      data: {
        name,
        description,
        active,
        images,
        placeId
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

// upload products category's photo

events.uploadProductsCategoryPhoto = async (
  token,
  companyId,
  appId,
  productsCategoryId,
  { filesForm }
) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/categories/products/' +
        productsCategoryId +
        '/photo',
      data: filesForm
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// upload products category's miniature photo

events.uploadProductsCategoryMiniaturePhoto = async (
  token,
  companyId,
  appId,
  productsCategoryId,
  { filesForm }
) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/categories/products/' +
        productsCategoryId +
        '/photo/miniature',
      data: filesForm
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

events.deleteProductsCategory = async (token, companyId, appId, productsCategoryId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/categories/products/' +
        productsCategoryId
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// Products:

events.getProducts = (token, companyId, appId, pagination, search, placeId, productsCategoryId) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.sortDesc,
        limit: pagination.itemsPerPage,
        search,
        placeId,
        productsCategoryId
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/products'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message === 'Operation canceled') return resolve(false)
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.createProduct = (
  token,
  companyId,
  appId,
  { sku, name, price, description, discountPrice, stock, active, productsCategories, placeId }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/products',
      data: {
        sku,
        name,
        price,
        description,
        discountPrice,
        stock,
        active,
        productsCategories,
        placeId
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

events.updateProduct = (
  token,
  productId,
  companyId,
  appId,
  { sku, name, price, description, discountPrice, stock, active, productsCategories, placeId }
) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/products/' +
        productId,
      data: {
        sku,
        name,
        price,
        description,
        discountPrice,
        stock,
        active,
        productsCategories,
        placeId
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

// upload product's photo

events.uploadProductPhoto = async (
  token,
  companyId,
  appId,
  productId,
  { filesForm }
) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/products/' +
        productId +
        '/photo',
      data: filesForm
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// upload product's miniature photo

events.uploadProductMiniaturePhoto = async (
  token,
  companyId,
  appId,
  productId,
  { filesForm }
) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/products/' +
        productId +
        '/photo/miniature',
      data: filesForm
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

events.deleteProduct = async (token, companyId, appId, productId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/products/' +
        productId
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    console.error(error)
    const errResponse = error.response
    if (!errResponse) {
      return false
    } else {
      console.error(errResponse)
      const message = errResponse.data.error || ''
      if (message) throw new Error(message)
      throw error
    }
  }
}

// Products purchases:

events.getProductsSales = (token, companyId, appId, pagination, search) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search
      },
      url:
        UrlBaseEvents +
        'admin/companies/' +
        companyId +
        '/apps/' +
        appId +
        '/purchases/products'
    }

    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message === 'Operation canceled') return resolve(false)
        console.error(error)
        const errResponse = error.response
        if (!errResponse) {
          return resolve(false)
        } else {
          console.error(errResponse)
          const message = errResponse.data.error || ''
          if (message) return reject(new Error(message))
          return reject(error)
        }
      })
  })
}

// Venues Categories and Preferences

events.createEventCategories = (token, companyId, appId, category) => {
  const request = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/events/categories`,
    data: {
      name: category.name,
      type: category.type,
      preferences: category.preferences,
      active: category.active
    }
  }
  return axios(request)
}

events.getEventCategories = (token, companyId, appId, pagination = {}, search) => {
  const request = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      page: pagination.page,
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      limit: pagination.itemsPerPage,
      search
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/events/categories`
  }
  return axios(request)
}

events.updateEventCategory = (token, companyId, appId, category, categoryId) => {
  const request = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/events/categories/${categoryId}`,
    data: {
      name: category.name,
      type: category.type,
      preferences: category.preferences,
      active: category.active
    }
  }
  return axios(request)
}

events.createPlaceCategories = (token, companyId, appId, category) => {
  const request = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/places/categories`,
    data: {
      name: category.name,
      type: category.type,
      preferences: category.preferences,
      active: category.active
    }
  }
  return axios(request)
}

events.updatePlaceCategory = (token, companyId, appId, category, categoryId) => {
  const request = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/places/categories/${categoryId}`,
    data: {
      name: category.name,
      type: category.type,
      preferences: category.preferences,
      active: category.active
    }
  }
  return axios(request)
}

events.getPlaceCategories = (token, companyId, appId, pagination = {}, search) => {
  const request = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      page: pagination.page,
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      limit: pagination.itemsPerPage,
      search
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/places/categories`
  }
  return axios(request)
}

events.createPlacePreferences = (token, companyId, appId, preference) => {
  const request = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/places/preferences`,
    data: {
      label: preference.label,
      type: preference.type,
      active: preference.active
    }
  }
  return axios(request)
}

events.getPlacePreferences = (token, companyId, appId, pagination = {}, search) => {
  const request = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      page: pagination.page,
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      limit: pagination.itemsPerPage,
      search
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/places/preferences`
  }
  return axios(request)
}
events.updatePlacePreference = (token, companyId, appId, preference, preferenceId) => {
  const request = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/places/preferences/${preferenceId}`,
    data: {
      label: preference.label,
      type: preference.type,
      active: preference.active
    }
  }
  return axios(request)
}

events.createEventPreferences = (token, companyId, appId, preference) => {
  const request = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/events/preferences`,
    data: {
      label: preference.label,
      type: preference.type,
      active: preference.active
    }
  }
  return axios(request)
}

events.getEventPreferences = (token, companyId, appId, pagination = {}, search) => {
  const request = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      page: pagination.page,
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      limit: pagination.itemsPerPage,
      search
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/events/preferences`
  }
  return axios(request)
}

events.updateEventPreference = (token, companyId, appId, preference, preferenceId) => {
  const request = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${UrlBaseEvents}admin/companies/${companyId}/apps/${appId}/events/preferences/${preferenceId}`,
    data: {
      label: preference.label,
      type: preference.type,
      active: preference.active
    }
  }
  return axios(request)
}

export default events
